import { Injectable } from '@angular/core';

import { DivRenderer } from './experimental.grid';

@Injectable()
export class InsightEpicBridge {
    renderer: DivRenderer;
}
